import { requestTool } from "../tools";

const CONTROLLER_URL = process.env.REACT_APP_CRUD_API_URL +"/api/CommonProperties/";

const GetIntersectOtherElementCommonProperties = async(_mdl) =>await requestTool.postRequest(CONTROLLER_URL + "GetIntersectOtherElementCommonProperties", _mdl);

export const getIntersectCommonPropertiesService = { GetIntersectOtherElementCommonProperties };

export default getIntersectCommonPropertiesService;


